var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-cell',{on:{"click":_vm.showPopup}},[_vm._v("展示弹出层")]),_c('van-popup',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("内容")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }